import { RadioGroup } from '@policygenius/mortar';
import React from 'react';

import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import styles from '../form-inputs.module.scss';
import { RadioButtonsFieldProps } from './types';

type Props = RadioButtonsFieldProps & FieldRenderProps<string>;

const RadioButtonsField = ({ input, meta, ...props }: Props) => (
  <div className={styles['field-container']}>
    <RadioGroup
      {...input}
      {...props}
      defaultValue={meta.initial}
      errorMessage={getErrorMessage(meta)}
      showGroupLabel
    />
  </div>
);

export default RadioButtonsField;
